// Redux Checkpoints Types
export const CHECKPOINTS_FETCH_SUCCESS = "CHECKPOINTS_FETCH_SUCCESS";
export const CHECKPOINTS_RESET = "CHECKPOINTS_RESET";
